import { useOptimizedRealtimeQuery } from './useOptimizedRealtimeQuery';

// Deprecated: Use useOptimizedRealtimeQuery instead
// This is kept for backward compatibility

interface RealtimeQueryOptions<T> {
  queryKey: (string | undefined)[];
  queryFn: () => Promise<T>;
  tableName: string;
  enabled?: boolean;
  staleTime?: number;
  gcTime?: number;
  refetchInterval?: number;
  debounceDelay?: number;
  forceRefresh?: boolean;
  enableToasts?: boolean;
  filter?: string;
  refetchOnMount?: boolean | 'always';
}

export function useRealtimeQuery<T>(options: RealtimeQueryOptions<T>) {
  // Redirect to optimized version with backward compatibility
  return useOptimizedRealtimeQuery(options);
}